//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('pickJobGrps', {
//        templateUrl: 'views/components/views/pickJobGrps/pickJobGrps.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'pickJobGrpsService', function ($stateParams, stateService, utilityService, pickJobGrpsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let stockPlaceId = $stateParams.stockplace_id;

//            vm.model = {
//                setting: {},
//                itemsListPickJobGroups: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await pickJobGrpsService.getSetting({ stockplace_id: stockPlaceId }))[0];

//                loadPickJobGroups();
//            }

//            async function loadPickJobGroups() {
//                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id) !== true) return;

//                vm.model.itemsListPickJobGroups = (await pickJobGrpsService.listPickJobGroups({ stockplace_id: vm.model.setting.stockplace_id }));
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'pickjobgrp':
//                        go({
//                            stockplace_id: vm.model.setting.stockplace_id,
//                            pickjobgrp_keyno: '0'
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadSetting();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
